module.exports = __webpack_public_path__ + "img/tiankang2.e354539a.jpeg";